// import React from "react";
// import { getBlogDetailById } from "../../store/Slice/blogDetailSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { getBlogListing } from "../../store/Slice/blogListingSlice";
// import { getCommentListing } from "../../store/Slice/commentListingSlice";
// import {
//   getAddCommentList,
//   ResetAddCommentState,
// } from "../../store/Slice/addCommentSlice";
// import { Toast } from "primereact/toast";
// import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";

// const BlogDetail = () => {
//   const toast = React.useRef(null);
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const blogId = location.state?.blogId;

//   const noImage = "/assets/images/no-image.png";

//   const isLoggedIn = sessionStorage.getItem("CustomerId");

//   const [comment, setComment] = React.useState("");
//   const [commentError, setCommentError] = React.useState("");
//   const [errorMessage, setErrorMessage] = React.useState(null);
//   const [loading, setLoading] = React.useState(false);

//   const { labelDetailData } = useSelector((state) => state.labelDetailList);

//   const path = location && location.pathname.split("/")[1];

//   const { blogDetailByIdData, loading: blogDetailLoading } = useSelector(
//     (state) => state.blogDetailById
//   );

//   const { blogListingData, loading: blogListingLoading } = useSelector(
//     (state) => state.blogListing
//   );

//   const { commentListingData } = useSelector((state) => state.commentListing);
//   const { addCommentData } = useSelector((state) => state.addCommentList);

//   const handleCommentChange = (event) => {
//     const commentValue = event.target.value;
//     setComment(commentValue);
//     event.target.value.trim() !== "" && setCommentError("");
//     if (commentValue.trim() === "" && commentValue.length === 0) {
//       setCommentError("This field is required.");
//     } else if (commentValue.length < 50) {
//       setCommentError("Comment must be at least 50 characters long.");
//     } else {
//       setCommentError("");
//     }
//   };

//   React.useEffect(() => {
//     setComment("");
//     setCommentError("");
//   }, [blogId]);

//   React.useEffect(() => {
//     if (blogId) {
//       dispatch(
//         getBlogDetailById({
//           iBlogId: blogId,
//         })
//       );
//     }
//   }, [dispatch, blogId]);

//   React.useEffect(() => {
//     if (!blogListingData) {
//       dispatch(getBlogListing());
//     }
//   }, [blogListingData, dispatch]);

//   const isStillBlogDetailLoading = React.useMemo(
//     () =>
//       blogDetailLoading ||
//       !blogDetailByIdData ||
//       typeof blogDetailByIdData.code === "undefined",
//     [blogDetailLoading, blogDetailByIdData]
//   );

//   const isStillBlogListingLoading = React.useMemo(
//     () =>
//       blogListingLoading ||
//       !blogListingData ||
//       typeof blogListingData.code === "undefined",
//     [blogListingLoading, blogListingData]
//   );

//   const handleBlogClick = (blogId, blogSlug) => {
//     navigate(`/blog-detail/${blogSlug}`, {
//       state: { blogId },
//     });
//   };

//   React.useEffect(() => {
//     dispatch(getLabelDetailList({ vSlug: path }));
//   }, [path, dispatch]);

//   React.useEffect(() => {
//     dispatch(
//       getCommentListing({
//         iBlogId: blogId,
//       })
//     );
//   }, [dispatch, blogId]);

//   const CommentCount =
//     commentListingData &&
//     commentListingData.code === 200 &&
//     commentListingData.data.length;

//   const validateCommentForm = React.useCallback(() => {
//     let isValid = true;
//     setCommentError("");

//     if (comment.trim() === "" && comment.length === 0) {
//       setCommentError("This field is required.");
//       isValid = false;
//     } else if (comment.length < 50) {
//       setCommentError("Comment must be at least 50 characters long.");
//       isValid = false;
//     }
//     return isValid;
//   }, [comment]);

//   const handleAddComment = React.useCallback(
//     (event) => {
//       event.preventDefault();

//       const isValidForm = validateCommentForm();
//       if (isValidForm) {
//         dispatch(
//           getAddCommentList({
//             iBlogId: blogId,
//             iCustomerId: Number(isLoggedIn),
//             vComment: comment,
//           })
//         );
//         setLoading(true);
//       } else {
//         // console.log("Something Went Wrong");
//       }
//     },
//     [dispatch, blogId, isLoggedIn, comment, validateCommentForm]
//   );

//   React.useEffect(() => {
//     if (addCommentData && addCommentData.code === 200) {
//       toast.current.show({
//         severity: "success",
//         summary: "Comment Added Successfully.",
//         life: 2000,
//         className: "custom-toast",
//       });
//       setTimeout(() => {
//         setLoading(false);
//         setComment("");
//         dispatch(
//           getCommentListing({
//             iBlogId: blogId,
//           })
//         );
//       }, 2000);
//       dispatch(ResetAddCommentState());
//     } else if (addCommentData && addCommentData.code === 404) {
//       setLoading(false);
//       setErrorMessage(addCommentData.message);
//     } else if (addCommentData && addCommentData.code === 400) {
//       setLoading(false);
//       setErrorMessage(addCommentData.message);
//     }
//   }, [addCommentData, dispatch, blogId]);

//   const labelMap = React.useMemo(() => {
//     if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
//       return new Map(
//         labelDetailData.data.map((item) => [item.vLabel, item.tText])
//       );
//     }
//     return new Map();
//   }, [labelDetailData]);

//   const commentsHeading =
//     labelMap.get("LBL_BLOGS_DETAIL_COMMENTS_HEADING") || "";
//   const recentBlogsHeading =
//     labelMap.get("LBL_BLOGS_DETAIL_RECENT_BLOGS_HEADING") || "";

//   return (
//     <section className="blogdetails-section ptb-100">
//       <Toast ref={toast} />
//       <div className="container">
//         <div className="row g-lg-5 g-4">
//           <div className="col-xl-8 col-lg-8 ">
//             <div className="row g-lg-4 g-4">
//               <div className="col-xl-12 col-lg-12 col-md-12">
//                 {isStillBlogDetailLoading ? null : blogDetailByIdData &&
//                   blogDetailByIdData.code === 200 &&
//                   blogDetailByIdData.data ? (
//                   <div className="blog-maincard blogdetails-card">
//                     <div className="blog-cardimgDiv">
//                       <img
//                         className="blog-cardimg"
//                         width={307}
//                         height={200}
//                         // src="/assets/images/blog/blog-detail.png"
//                         src={
//                           blogDetailByIdData?.data?.vImage &&
//                           !blogDetailByIdData?.data?.vImage.endsWith(null)
//                             ? blogDetailByIdData?.data?.vImage
//                             : noImage
//                         }
//                         alt={blogDetailByIdData?.data?.vImageAlt}
//                       />
//                     </div>
//                     <div className="blogcard-content">
//                       <div className="blogtype-dateDiv">
//                         <span className="blogclean-type">
//                           {blogDetailByIdData.data.category.vCategory}
//                         </span>
//                         <span className="blogviewdate detail-data">
//                           {blogDetailByIdData.data.dtAddedDate}
//                         </span>
//                       </div>
//                       <h2 className="main-title">
//                         {blogDetailByIdData.data.vBlog}
//                       </h2>
//                       <p
//                         dangerouslySetInnerHTML={{
//                           __html: blogDetailByIdData.data.tDescription,
//                         }}
//                       />
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="col-12">
//                     <p
//                       style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         padding: "10px 0",
//                       }}
//                     >
//                       No Data Found
//                     </p>
//                   </div>
//                 )}

//                 <div
//                   className="blog-maincard blogdetails-card comment-sendreply-mainDiv"
//                   // style={{ marginTop: "10px" }}
//                 >
//                   <div className="mt-lg-4 mt-3">
//                     <h2 className="main-title mb-3">
//                       {commentsHeading}{" "}
//                       <span className="comment-count">
//                         {CommentCount > 0 ? `(${CommentCount})` : ""}
//                       </span>
//                     </h2>
//                     <div className="comment-section">
//                       <div className="form-group mb-3">
//                         <textarea
//                           className="form-control"
//                           placeholder="Additional Comments.."
//                           value={comment}
//                           onChange={isLoggedIn ? handleCommentChange : null}
//                           // disabled={!isLoggedIn}
//                           maxLength={250}
//                         />
//                         {isLoggedIn && commentError && (
//                           <div className="validation-error">{commentError}</div>
//                         )}
//                       </div>
//                     </div>
//                     {errorMessage && (
//                       <div className="validation-error">{errorMessage}</div>
//                     )}
//                     {loading ? (
//                       <>
//                         {" "}
//                         <button
//                           className="success-orangebtn"
//                           type="button"
//                           disabled
//                         >
//                           <span
//                             className="spinner-border spinner-border-sm me-1 custom-spinner"
//                             role="status"
//                             aria-hidden="true"
//                           ></span>
//                           Loading...
//                         </button>
//                       </>
//                     ) : (
//                       <button
//                         type="submit"
//                         className="success-orangebtn"
//                         onClick={handleAddComment}
//                       >
//                         Submit
//                       </button>
//                     )}

//                     {commentListingData &&
//                     commentListingData.code === 200 &&
//                     commentListingData.data ? (
//                       <div className="comment-sendreply-Box">
//                         {commentListingData.data.map(
//                           (comment, commentIndex) => (
//                             <div
//                               className="comment-sendreply-mainDiv"
//                               key={commentIndex}
//                             >
//                               <div className="send-commentDiv">
//                                 <img
//                                   className="comment-img"
//                                   width={50}
//                                   height={50}
//                                   // src="/assets/images/blog/comment1.png"
//                                   src={
//                                     comment?.customer?.vImage &&
//                                     !comment?.customer?.vImage.endsWith(null)
//                                       ? comment?.customer?.vImage
//                                       : noImage
//                                   }
//                                   alt={comment?.customer?.vImageAlt}
//                                 />
//                                 <div className="comment-content">
//                                   <h3 className="comment-title">
//                                     {comment.customer.vFullName}
//                                   </h3>
//                                   <p>{comment.vComment}</p>
//                                 </div>
//                               </div>
//                             </div>
//                           )
//                         )}
//                       </div>
//                     ) : (
//                       <></>
//                       // <div className="col-12">
//                       //   <p
//                       //     style={{
//                       //       display: "flex",
//                       //       justifyContent: "center",
//                       //       alignItems: "center",
//                       //       padding: "10px 0",
//                       //     }}
//                       //   >
//                       //     No Data Found
//                       //   </p>
//                       // </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-xl-4 col-lg-4 blog-sidebar-sticky">
//             <div className="d-flex flex-column gap-lg-4 gap-4">
//               <div className="categories-card recentblog-card">
//                 <h3 className="medium-title">{recentBlogsHeading}</h3>
//                 {isStillBlogListingLoading ? null : blogListingData &&
//                   blogListingData.code === 200 &&
//                   blogListingData.data ? (
//                   <div className="d-flex flex-column gap-lg-4 gap-4">
//                     {[...blogListingData.data]
//                       .sort(
//                         (a, b) =>
//                           new Date(b.dtAddedDate) - new Date(a.dtAddedDate)
//                       )
//                       .splice(0, 3) // ascending order based on blogId
//                       .map((recentBlog, recentBlogIndex) => (
//                         <div className="blog-maincard" key={recentBlogIndex}>
//                           <div className="blog-cardimgDiv">
//                             <img
//                               style={{ cursor: "pointer" }}
//                               onClick={() =>
//                                 handleBlogClick(
//                                   recentBlog.iBlogId,
//                                   recentBlog.vSlug
//                                 )
//                               }
//                               className="blog-cardimg"
//                               width={307}
//                               height={200}
//                               // src="/assets/images/blog/blog4.png"
//                               src={
//                                 recentBlog.vImage &&
//                                 !recentBlog.vImage.endsWith(null)
//                                   ? recentBlog.vImage
//                                   : noImage
//                               }
//                               alt={recentBlog.vImageAlt}
//                             />
//                             <span
//                               className="blogviewdate"
//                               style={{ cursor: "pointer" }}
//                               onClick={() =>
//                                 handleBlogClick(
//                                   recentBlog.iBlogId,
//                                   recentBlog.vSlug
//                                 )
//                               }
//                             >
//                               {recentBlog.dtAddedDate}
//                             </span>
//                           </div>
//                           <div className="blogcard-content">
//                             <div className="blogtype-dateDiv">
//                               <span
//                                 className="blogclean-type"
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() =>
//                                   handleBlogClick(
//                                     recentBlog.iBlogId,
//                                     recentBlog.vSlug
//                                   )
//                                 }
//                               >
//                                 {recentBlog.category.vCategory}
//                               </span>
//                             </div>
//                             <div
//                               // href="/blog-detail"
//                               className="text-decoration-none"
//                             >
//                               <h2
//                                 className="medium-title"
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() =>
//                                   handleBlogClick(
//                                     recentBlog.iBlogId,
//                                     recentBlog.vSlug
//                                   )
//                                 }
//                               >
//                                 {recentBlog.vBlog}
//                               </h2>
//                             </div>
//                             <div
//                               className="blog-cont"
//                               style={{ cursor: "pointer" }}
//                               onClick={() =>
//                                 handleBlogClick(
//                                   recentBlog.iBlogId,
//                                   recentBlog.vSlug
//                                 )
//                               }
//                               dangerouslySetInnerHTML={{
//                                 __html: recentBlog.tDescription,
//                               }}
//                             />
//                           </div>
//                         </div>
//                       ))}

//                     {/* <div className="blog-maincard">
//                       <div className="blog-cardimgDiv">
//                         <img
//                           className="blog-cardimg"
//                           width={307}
//                           height={200}
//                           src="/assets/images/blog/blog3.png"
//                           alt="Blog"
//                         />
//                       </div>
//                       <div className="blogcard-content">
//                         <div className="blogtype-dateDiv">
//                           <span className="blogclean-type">Floor Cleaning</span>
//                           <span className="blogviewdate">
//                             November 28, 2024
//                           </span>
//                         </div>
//                         <a href="/blog-detail" className="text-decoration-none">
//                           <h2 className="medium-title">Floor Cleaning</h2>
//                         </a>
//                         <p>
//                           Lorem ipsum dolor sit amet consectetur. Elit euismod
//                           lorem nunc lobortis lacus duis{" "}
//                         </p>
//                       </div>
//                     </div>
//                     <div className="blog-maincard">
//                       <div className="blog-cardimgDiv">
//                         <img
//                           className="blog-cardimg"
//                           width={307}
//                           height={200}
//                           src="/assets/images/blog/blog2.png"
//                           alt="Blog"
//                         />
//                       </div>
//                       <div className="blogcard-content">
//                         <div className="blogtype-dateDiv">
//                           <span className="blogclean-type">
//                             Carpet Cleaning
//                           </span>
//                           <span className="blogviewdate">June 18, 2024</span>
//                         </div>
//                         <a href="/blog-detail" className="text-decoration-none">
//                           <h2 className="medium-title">Carpet Cleaning</h2>
//                         </a>
//                         <p>
//                           Lorem ipsum dolor sit amet consectetur. Elit euismod
//                           lorem nunc lobortis lacus duis{" "}
//                         </p>
//                       </div>
//                     </div> */}
//                   </div>
//                 ) : (
//                   <div className="col-12">
//                     <p
//                       style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         padding: "10px 0",
//                       }}
//                     >
//                       No Data Found
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BlogDetail;

import React from "react";
import { getBlogDetailById } from "../../store/Slice/blogDetailSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getBlogListing } from "../../store/Slice/blogListingSlice";
import { getCommentListing } from "../../store/Slice/commentListingSlice";
import {
  getAddCommentList,
  ResetAddCommentState,
} from "../../store/Slice/addCommentSlice";
import { Toast } from "primereact/toast";
import { getLabelDetailList } from "../../store/Slice/labelDetailSlice";

const BlogDetail = () => {
  const toast = React.useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  
  // Get blogId from location state (for internal navigation)
  const blogId = location.state?.blogId;
  // Get vSlug from URL parameters (for direct URL access) - MATCHING YOUR ROUTE
  const blogSlug = params.vSlug; // Changed from params.blogSlug to params.vSlug
  
  // State for storing blog ID found from slug
  const [blogIdFromSlug, setBlogIdFromSlug] = React.useState(null);
  const [isLookingUpSlug, setIsLookingUpSlug] = React.useState(false);

  const noImage = "/assets/images/no-image.png";

  const isLoggedIn = sessionStorage.getItem("CustomerId");

  const [comment, setComment] = React.useState("");
  const [commentError, setCommentError] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const { labelDetailData } = useSelector((state) => state.labelDetailList);

  const path = location && location.pathname.split("/")[1];

  const { blogDetailByIdData, loading: blogDetailLoading } = useSelector(
    (state) => state.blogDetailById
  );

  const { blogListingData, loading: blogListingLoading } = useSelector(
    (state) => state.blogListing
  );

  const { commentListingData } = useSelector((state) => state.commentListing);
  const { addCommentData } = useSelector((state) => state.addCommentList);

  const handleCommentChange = (event) => {
    const commentValue = event.target.value;
    setComment(commentValue);
    event.target.value.trim() !== "" && setCommentError("");
    if (commentValue.trim() === "" && commentValue.length === 0) {
      setCommentError("This field is required.");
    } else if (commentValue.length < 50) {
      setCommentError("Comment must be at least 50 characters long.");
    } else {
      setCommentError("");
    }
  };

  React.useEffect(() => {
    setComment("");
    setCommentError("");
  }, [blogId, blogIdFromSlug]);

  // Find blog ID from slug when directly accessing URL
  React.useEffect(() => {
    const findBlogIdFromSlug = async () => {
      // If we have slug, no blogId from state, and blog listing data is available
      if (blogSlug && !blogId && blogListingData?.code === 200 && blogListingData.data) {
        setIsLookingUpSlug(true);
        console.log("Looking for blog with vSlug:", blogSlug);
        
        // Find blog by vSlug (matching your API field name)
        const blog = blogListingData.data.find(blog => blog.vSlug === blogSlug);
        if (blog) {
          console.log("Found blog ID:", blog.iBlogId);
          setBlogIdFromSlug(blog.iBlogId);
        } else {
          console.log("No blog found with vSlug:", blogSlug);
          setErrorMessage("Blog not found");
        }
        setIsLookingUpSlug(false);
      }
    };

    findBlogIdFromSlug();
  }, [blogSlug, blogId, blogListingData]);

  // Fetch blog details using either blogId from state or from slug
  React.useEffect(() => {
    const idToFetch = blogId || blogIdFromSlug;
    
    if (idToFetch) {
      console.log("Fetching blog details for ID:", idToFetch);
      dispatch(
        getBlogDetailById({
          iBlogId: idToFetch,
        })
      );
    }
  }, [dispatch, blogId, blogIdFromSlug]);

  React.useEffect(() => {
    if (!blogListingData) {
      dispatch(getBlogListing());
    }
  }, [blogListingData, dispatch]);

  const isStillBlogDetailLoading = React.useMemo(
    () =>
      blogDetailLoading ||
      !blogDetailByIdData ||
      typeof blogDetailByIdData.code === "undefined",
    [blogDetailLoading, blogDetailByIdData]
  );

  const isStillBlogListingLoading = React.useMemo(
    () =>
      blogListingLoading ||
      !blogListingData ||
      typeof blogListingData.code === "undefined",
    [blogListingLoading, blogListingData]
  );

  const handleBlogClick = (blogId, blogSlug) => {
    navigate(`/blog-detail/${blogSlug}`, {
      state: { blogId },
    });
  };

  React.useEffect(() => {
    dispatch(getLabelDetailList({ vSlug: path }));
  }, [path, dispatch]);

  // Fetch comments using the correct ID
  React.useEffect(() => {
    const idToFetch = blogId || blogIdFromSlug;
    
    if (idToFetch) {
      dispatch(
        getCommentListing({
          iBlogId: idToFetch,
        })
      );
    }
  }, [dispatch, blogId, blogIdFromSlug]);

  const CommentCount =
    commentListingData &&
    commentListingData.code === 200 &&
    commentListingData.data
      ? commentListingData.data.length
      : 0;

  const validateCommentForm = React.useCallback(() => {
    let isValid = true;
    setCommentError("");

    if (comment.trim() === "" && comment.length === 0) {
      setCommentError("This field is required.");
      isValid = false;
    } else if (comment.length < 50) {
      setCommentError("Comment must be at least 50 characters long.");
      isValid = false;
    }
    return isValid;
  }, [comment]);

  // Handle add comment with correct ID
  const handleAddComment = React.useCallback(
    (event) => {
      event.preventDefault();

      const idToUse = blogId || blogIdFromSlug;
      if (!idToUse) {
        setErrorMessage("Blog ID not found");
        return;
      }

      if (!isLoggedIn) {
        setErrorMessage("Please login to comment");
        return;
      }

      const isValidForm = validateCommentForm();
      if (isValidForm) {
        dispatch(
          getAddCommentList({
            iBlogId: idToUse,
            iCustomerId: Number(isLoggedIn),
            vComment: comment,
          })
        );
        setLoading(true);
        setErrorMessage(null);
      }
    },
    [dispatch, blogId, blogIdFromSlug, isLoggedIn, comment, validateCommentForm]
  );

  // Handle add comment response
  React.useEffect(() => {
    if (addCommentData) {
      if (addCommentData.code === 200) {
        toast.current.show({
          severity: "success",
          summary: "Comment Added Successfully.",
          life: 2000,
          className: "custom-toast",
        });
        
        setTimeout(() => {
          setLoading(false);
          setComment("");
          const idToFetch = blogId || blogIdFromSlug;
          if (idToFetch) {
            dispatch(
              getCommentListing({
                iBlogId: idToFetch,
              })
            );
          }
        }, 2000);
        dispatch(ResetAddCommentState());
      } else if (addCommentData.code === 404 || addCommentData.code === 400) {
        setLoading(false);
        setErrorMessage(addCommentData.message);
        dispatch(ResetAddCommentState());
      }
    }
  }, [addCommentData, dispatch, blogId, blogIdFromSlug]);

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const commentsHeading =
    labelMap.get("LBL_BLOGS_DETAIL_COMMENTS_HEADING") || "Comments";
  const recentBlogsHeading =
    labelMap.get("LBL_BLOGS_DETAIL_RECENT_BLOGS_HEADING") || "Recent Blogs";

  // Show loading state while looking up slug
  if (isLookingUpSlug) {
    return (
      <section className="blogdetails-section ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <p>Loading blog...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="blogdetails-section ptb-100">
      <Toast ref={toast} />
      <div className="container">
        <div className="row g-lg-5 g-4">
          <div className="col-xl-8 col-lg-8 ">
            <div className="row g-lg-4 g-4">
              <div className="col-xl-12 col-lg-12 col-md-12">
                {isStillBlogDetailLoading ? (
                  <div className="text-center">
                    {/* <p>Loading blog details...</p> */}
                  </div>
                ) : blogDetailByIdData &&
                  blogDetailByIdData.code === 200 &&
                  blogDetailByIdData.data ? (
                  <div className="blog-maincard blogdetails-card">
                    <div className="blog-cardimgDiv">
                      <img
                        className="blog-cardimg"
                        width={307}
                        height={200}
                        src={
                          blogDetailByIdData?.data?.vImage &&
                          !blogDetailByIdData?.data?.vImage.endsWith("null")
                            ? blogDetailByIdData?.data?.vImage
                            : noImage
                        }
                        alt={blogDetailByIdData?.data?.vImageAlt || "Blog"}
                      />
                    </div>
                    <div className="blogcard-content">
                      <div className="blogtype-dateDiv">
                        <span className="blogclean-type">
                          {blogDetailByIdData.data.category?.vCategory || "Uncategorized"}
                        </span>
                        <span className="blogviewdate detail-data">
                          {blogDetailByIdData.data.dtAddedDate}
                        </span>
                      </div>
                      <h2 className="main-title">
                        {blogDetailByIdData.data.vBlog}
                      </h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: blogDetailByIdData.data.tDescription,
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px 0",
                      }}
                    >
                      No Data Found
                    </p>
                  </div>
                )}

                <div className="blog-maincard blogdetails-card comment-sendreply-mainDiv">
                  <div className="mt-lg-4 mt-3">
                    <h2 className="main-title mb-3">
                      {commentsHeading}{" "}
                      <span className="comment-count">
                        {CommentCount > 0 ? `(${CommentCount})` : ""}
                      </span>
                    </h2>
                    
                    {/* Comment Form */}
                    <div className="comment-section">
                      <div className="form-group mb-3">
                        <textarea
                          className="form-control"
                          placeholder={isLoggedIn ? "Additional Comments.." : "Please login to comment"}
                          value={comment}
                          onChange={isLoggedIn ? handleCommentChange : null}
                          disabled={!isLoggedIn}
                          maxLength={250}
                          rows={4}
                        />
                        {isLoggedIn && commentError && (
                          <div className="validation-error">{commentError}</div>
                        )}
                      </div>
                    </div>
                    
                    {errorMessage && (
                      <div className="validation-error">{errorMessage}</div>
                    )}
                    
                    {loading ? (
                      <button
                        className="success-orangebtn"
                        type="button"
                        disabled
                      >
                        <span
                          className="spinner-border spinner-border-sm me-1 custom-spinner"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="success-orangebtn"
                        onClick={handleAddComment}
                        disabled={!isLoggedIn}
                      >
                        Submit
                      </button>
                    )}

                    {/* Comments List */}
                    {commentListingData &&
                    commentListingData.code === 200 &&
                    commentListingData.data &&
                    commentListingData.data.length > 0 ? (
                      <div className="comment-sendreply-Box mt-4">
                        {commentListingData.data.map((comment, commentIndex) => (
                          <div
                            className="comment-sendreply-mainDiv"
                            key={commentIndex}
                          >
                            <div className="send-commentDiv">
                              <img
                                className="comment-img"
                                width={50}
                                height={50}
                                src={
                                  comment?.customer?.vImage &&
                                  !comment?.customer?.vImage.endsWith("null")
                                    ? comment?.customer?.vImage
                                    : noImage
                                }
                                alt={comment?.customer?.vImageAlt || "User"}
                              />
                              <div className="comment-content">
                                <h3 className="comment-title">
                                  {comment.customer?.vFullName || "Anonymous"}
                                </h3>
                                <p>{comment.vComment}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="mt-4">
                        <p className="text-muted">No comments yet. Be the first to comment!</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Blogs Sidebar - Rest of your JSX remains the same */}
          <div className="col-xl-4 col-lg-4 blog-sidebar-sticky">
            <div className="d-flex flex-column gap-lg-4 gap-4">
              <div className="categories-card recentblog-card">
                <h3 className="medium-title">{recentBlogsHeading}</h3>
                {isStillBlogListingLoading ? (
                  <div className="text-center">
                    <p>Loading recent blogs...</p>
                  </div>
                ) : blogListingData &&
                  blogListingData.code === 200 &&
                  blogListingData.data &&
                  blogListingData.data.length > 0 ? (
                  <div className="d-flex flex-column gap-lg-4 gap-4">
                    {[...blogListingData.data]
                      .filter(blog => blog.iBlogId !== (blogId || blogIdFromSlug))
                      .sort(
                        (a, b) =>
                          new Date(b.dtAddedDate) - new Date(a.dtAddedDate)
                      )
                      .slice(0, 3)
                      .map((recentBlog, recentBlogIndex) => (
                        <div className="blog-maincard" key={recentBlogIndex}>
                          <div className="blog-cardimgDiv">
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleBlogClick(
                                  recentBlog.iBlogId,
                                  recentBlog.vSlug
                                )
                              }
                              className="blog-cardimg"
                              width={307}
                              height={200}
                              src={
                                recentBlog.vImage &&
                                !recentBlog.vImage.endsWith("null")
                                  ? recentBlog.vImage
                                  : noImage
                              }
                              alt={recentBlog.vImageAlt || "Blog"}
                            />
                            <span
                              className="blogviewdate"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleBlogClick(
                                  recentBlog.iBlogId,
                                  recentBlog.vSlug
                                )
                              }
                            >
                              {recentBlog.dtAddedDate}
                            </span>
                          </div>
                          <div className="blogcard-content">
                            <div className="blogtype-dateDiv">
                              <span
                                className="blogclean-type"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleBlogClick(
                                    recentBlog.iBlogId,
                                    recentBlog.vSlug
                                  )
                                }
                              >
                                {recentBlog.category?.vCategory || "Uncategorized"}
                              </span>
                            </div>
                            <div className="text-decoration-none">
                              <h2
                                className="medium-title"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleBlogClick(
                                    recentBlog.iBlogId,
                                    recentBlog.vSlug
                                  )
                                }
                              >
                                {recentBlog.vBlog}
                              </h2>
                            </div>
                            <div
                              className="blog-cont"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleBlogClick(
                                  recentBlog.iBlogId,
                                  recentBlog.vSlug
                                )
                              }
                              dangerouslySetInnerHTML={{
                                __html: recentBlog.tDescription?.substring(0, 100) + "...",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="col-12">
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px 0",
                      }}
                    >
                      No Recent Blogs Found
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetail;